import Vue from 'vue';
import Router from 'vue-router';
import Dashboard from '@/components/Dashboard';
import Placeholder from '@/components/Placeholder';


Vue.use(Router);

export default new Router({
  routes: [
    // {
      // path: '/',
      // name: 'Dashboard',
      // component: Dashboard,
    // },
     {
        path: '/',
        name: 'Placeholder',
        component: Placeholder,
      }, 
  ],
});



// WEBPACK FOOTER //
// ./src/router/index.js